import React from 'react';
import cn from 'classnames';
import styles from './RequestCountCardSkeleton.module.scss';

const RequestCountCardSkeleton = ({ className, style }) => {
  return (
    <div
      className={cn(styles.tileSkeleton, className)}
      style={style}
    >
      <div className={styles.title} />
      <div className={styles.content} />
      <div className={styles.subtitle} />
    </div>
  );
};

export default RequestCountCardSkeleton;
